import {useMemo} from 'react';

export default (ITMFData: any, cgid: string | null) => {
	const rootItem = ITMFData?.navigationItemCollection?.items?.[0];

	const subItems = useMemo(() => {
		return rootItem?.subItemsCollection?.items?.map((item: any) => {

			item.editorialContent?.contentCollection?.items?.forEach((img: any) => delete img.image.title);
			delete item.image.title;

			return {
				category: item.category?.items?.[0]?.id,
				title: item.title,
				image: item.image,
				hoverImg: item.editorialContent?.contentCollection?.items?.[0],
			};
		});
	}, [rootItem]);

	const isITMF = useMemo(() => {
		return subItems?.map((subItem: any) => subItem.category)?.includes(cgid) ?? false;
	}, [cgid, subItems]);

	if (!rootItem) {
		return {isITMF: false, processedITMFData: undefined};
	}

	const processedITMFData = {title: rootItem.title, subItems};

	return {
		isITMF,
		processedITMFData,
	};
};